<template>
  <div class="hp-upload">
    <label v-if="label" class="hp-upload__label">{{ label }}</label>
    <div class="hp-upload__row">
      <div class="hp-upload__thumb" :class="{ empty: !value }">
        <img v-if="value" :src="value" :alt="label || 'preview'">
        <span v-else>بدون تصویر</span>
      </div>
      <div class="hp-upload__fields">
        <input
          class="hp-upload__input"
          type="text"
          :value="value"
          placeholder="آدرس تصویر یا آپلود کنید"
          @input="$emit('input', $event.target.value)"
        >
        <input ref="file" type="file" accept="image/*" class="d-none" @change="onFile">
        <div class="hp-upload__actions">
          <button type="button" class="pl-btn pl-btn--sm pl-btn--ghost" :disabled="busy" @click="$refs.file.click()">
            {{ busy ? 'در حال آپلود...' : 'آپلود تصویر' }}
          </button>
          <button v-if="value" type="button" class="pl-btn pl-btn--sm pl-btn--ghost hp-upload__clear" @click="$emit('input', '')">
            حذف
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadHomepageImage } from './hpApi'

export default {
  name: 'HpImageUpload',
  props: { value: { type: String, default: '' }, label: { type: String, default: '' } },
  data() {
    return { busy: false }
  },
  methods: {
    notify(msg) {
      if (this.$toast) this.$toast.open({ message: msg, type: 'error' })
      else alert(msg)
    },
    onFile(e) {
      const f = e.target.files && e.target.files[0]
      if (!f) return
      this.busy = true
      uploadHomepageImage(f).then((res) => {
        if (res.data && res.data.url) this.$emit('input', res.data.url)
        else this.notify((res.data && res.data.msg) || 'خطا در آپلود')
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.msg) || 'خطا در آپلود'
        this.notify(msg)
      }).finally(() => {
        this.busy = false
        e.target.value = ''
      })
    }
  }
}
</script>

<style scoped>
.hp-upload__label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
  color: var(--panel-muted, #6b7280);
}

.hp-upload__row {
  display: flex;
  align-items: stretch;
  gap: 10px;
}

.hp-upload__thumb {
  width: 96px;
  height: 64px;
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--panel-surface, #fff);
  flex-shrink: 0;
  font-size: 11px;
  color: var(--panel-muted, #9ca3af);
}

.hp-upload__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hp-upload__fields {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.hp-upload__input {
  width: 100%;
  min-height: 34px;
  padding: 6px 10px;
  border: 1px solid var(--panel-border, #e5e7eb);
  border-radius: 10px;
  background: var(--panel-surface, #fff);
  color: var(--panel-text, #111827);
  font-family: inherit;
  font-size: 12px;
  outline: none;
  box-shadow: none;
}

.hp-upload__input:focus {
  border-color: #111111;
}

.hp-upload__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.hp-upload__clear {
  color: #dc2626 !important;
  border-color: rgba(220, 38, 38, .25) !important;
}

/* local fallbacks if parent page styles don't cascade into child */
.pl-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 30px;
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid var(--panel-border, #e5e7eb);
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: var(--panel-surface, #fff);
  color: var(--panel-text, #111827);
}

.pl-btn:disabled {
  opacity: .6;
  cursor: not-allowed;
}

.pl-btn--ghost:hover {
  background: var(--panel-surface-2, #f8fafc);
}
</style>
